import { render } from "./rating.vue?vue&type=template&id=2aa4e4c8"
import script from "./rating.vue?vue&type=script&lang=js"
export * from "./rating.vue?vue&type=script&lang=js"

import "./rating.vue?vue&type=style&index=0&id=2aa4e4c8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__